import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, CameraOff, ScanLine } from "lucide-react";

export default function QrScanner() {
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [manual, setManual] = useState("");
  const scannerRef = useRef(null);
  const navigate = useNavigate();

  const handleDecoded = (text) => {
    const m = text.match(/\/invoice\/([A-Za-z0-9\-_]+)/);
    const token = m ? m[1] : (/^[A-Za-z0-9\-_]{20,}$/.test(text.trim()) ? text.trim() : null);
    if (token) {
      stop();
      navigate(`/invoice/${token}`);
    } else {
      setError("الرمز المقروء لا يخص سهول جنين.");
    }
  };

  const stop = async () => {
    try { await scannerRef.current?.stop(); scannerRef.current?.clear(); } catch { /* ignore */ }
    scannerRef.current = null;
    setActive(false);
  };

  const start = async () => {
    setError("");
    try {
      const { Html5Qrcode } = await import("html5-qrcode");
      const el = document.getElementById("qr-reader");
      if (!el) return;
      const scanner = new Html5Qrcode("qr-reader");
      scannerRef.current = scanner;
      setActive(true);
      await scanner.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        handleDecoded,
        () => {}
      );
    } catch (e) {
      setActive(false);
      setError("تعذّر فتح الكاميرا. تأكد من منح الإذن، أو أدخل الرمز يدويًا.");
    }
  };

  useEffect(() => () => { scannerRef.current?.stop().catch(() => {}); }, []);

  return (
    <div data-testid="qr-scanner" className="rounded-3xl border border-olive/10 bg-white p-6">
      <div className="mb-4 flex items-center gap-2">
        <ScanLine className="h-5 w-5 text-olive" />
        <h3 className="font-display text-lg font-bold text-ink">مسح QR من الطرد</h3>
      </div>
      <p className="mb-5 text-sm text-ink/55">امسح رمز QR المطبوع على طردك لعرض فاتورتك الإلكترونية.</p>

      {!active ? (
        <button data-testid="qr-start" onClick={start}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-olive py-3.5 font-semibold text-ivory transition-colors hover:bg-olive-dark">
          <Camera className="h-5 w-5" /> فتح الكاميرا والمسح
        </button>
      ) : (
        <button data-testid="qr-stop" onClick={stop}
          className="flex w-full items-center justify-center gap-2 rounded-full border border-palred/30 py-3 font-semibold text-palred">
          <CameraOff className="h-5 w-5" /> إيقاف الكاميرا
        </button>
      )}

      <div id="qr-reader" className={`mt-4 overflow-hidden rounded-2xl ${active ? "" : "hidden"}`} />

      {error && <p data-testid="qr-error" className="mt-4 rounded-xl bg-palred/8 px-4 py-3 text-sm text-palred">{error}</p>}

      <div className="mt-6 border-t border-olive/10 pt-5">
        <label className="mb-1.5 block text-sm text-ink/60">أو أدخل رمز الطرد يدويًا</label>
        <div className="flex gap-2">
          <input data-testid="qr-manual" value={manual} onChange={(e) => setManual(e.target.value)} dir="ltr"
            placeholder="QR token"
            className="flex-1 rounded-xl border border-olive/20 bg-white px-4 py-3 text-left text-sm outline-none focus:border-olive" />
          <button data-testid="qr-manual-go" onClick={() => handleDecoded(manual)}
            className="rounded-xl bg-olive px-5 text-sm font-semibold text-ivory">عرض</button>
        </div>
      </div>
    </div>
  );
}
